// @generated by protoc-gen-connect-es v1.4.0 with parameter "target=ts"
// @generated from file gitpod/v1/runner_configuration.proto (package gitpod.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { CreateEnvironmentClassRequest, CreateEnvironmentClassResponse, CreateHostAuthenticationTokenRequest, CreateHostAuthenticationTokenResponse, CreateLLMIntegrationRequest, CreateLLMIntegrationResponse, CreateSCMIntegrationRequest, CreateSCMIntegrationResponse, DeleteHostAuthenticationTokenRequest, DeleteHostAuthenticationTokenResponse, DeleteLLMIntegrationRequest, DeleteLLMIntegrationResponse, DeleteSCMIntegrationRequest, DeleteSCMIntegrationResponse, GetEnvironmentClassRequest, GetEnvironmentClassResponse, GetHostAuthenticationTokenRequest, GetHostAuthenticationTokenResponse, GetLLMIntegrationRequest, GetLLMIntegrationResponse, GetRunnerConfigurationSchemaRequest, GetRunnerConfigurationSchemaResponse, GetSCMIntegrationRequest, GetSCMIntegrationResponse, ListEnvironmentClassesRequest, ListEnvironmentClassesResponse, ListHostAuthenticationTokensRequest, ListHostAuthenticationTokensResponse, ListLLMIntegrationsRequest, ListLLMIntegrationsResponse, ListSCMIntegrationsRequest, ListSCMIntegrationsResponse, UpdateEnvironmentClassRequest, UpdateEnvironmentClassResponse, UpdateHostAuthenticationTokenRequest, UpdateHostAuthenticationTokenResponse, UpdateLLMIntegrationRequest, UpdateLLMIntegrationResponse, UpdateSCMIntegrationRequest, UpdateSCMIntegrationResponse, ValidateRunnerConfigurationRequest, ValidateRunnerConfigurationResponse } from "./runner_configuration_pb.js";
import { MethodIdempotency, MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service gitpod.v1.RunnerConfigurationService
 */
export const RunnerConfigurationService = {
  typeName: "gitpod.v1.RunnerConfigurationService",
  methods: {
    /**
     * Creates a new authentication token for accessing remote hosts.
     *
     * Use this method to:
     * - Set up SCM authentication
     * - Configure OAuth credentials
     * - Manage PAT tokens
     *
     * ### Examples
     *
     * - Create OAuth token:
     *
     *   Creates a new OAuth-based authentication token.
     *
     *   ```yaml
     *   runnerId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
     *   userId: "f53d2330-3795-4c5d-a1f3-453121af9c60"
     *   host: "github.com"
     *   token: "gho_xxxxxxxxxxxx"
     *   source: HOST_AUTHENTICATION_TOKEN_SOURCE_OAUTH
     *   expiresAt: "2024-12-31T23:59:59Z"
     *   refreshToken: "ghr_xxxxxxxxxxxx"
     *   ```
     *
     * @generated from rpc gitpod.v1.RunnerConfigurationService.CreateHostAuthenticationToken
     */
    createHostAuthenticationToken: {
      name: "CreateHostAuthenticationToken",
      I: CreateHostAuthenticationTokenRequest,
      O: CreateHostAuthenticationTokenResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Gets details about a specific host authentication token.
     *
     * Use this method to:
     * - View token information
     * - Check token expiration
     * - Verify token validity
     *
     * ### Examples
     *
     * - Get token details:
     *
     *   Retrieves information about a specific token.
     *
     *   ```yaml
     *   id: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
     *   ```
     *
     * @generated from rpc gitpod.v1.RunnerConfigurationService.GetHostAuthenticationToken
     */
    getHostAuthenticationToken: {
      name: "GetHostAuthenticationToken",
      I: GetHostAuthenticationTokenRequest,
      O: GetHostAuthenticationTokenResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
    /**
     * Lists host authentication tokens with optional filtering.
     *
     * Use this method to:
     * - View all tokens
     * - Filter by runner or user
     * - Monitor token status
     *
     * ### Examples
     *
     * - List all tokens:
     *
     *   Shows all tokens with pagination.
     *
     *   ```yaml
     *   pagination:
     *     pageSize: 20
     *   ```
     *
     * - Filter by runner:
     *
     *   Lists tokens for a specific runner.
     *
     *   ```yaml
     *   filter:
     *     runnerId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
     *   pagination:
     *     pageSize: 20
     *   ```
     *
     * @generated from rpc gitpod.v1.RunnerConfigurationService.ListHostAuthenticationTokens
     */
    listHostAuthenticationTokens: {
      name: "ListHostAuthenticationTokens",
      I: ListHostAuthenticationTokensRequest,
      O: ListHostAuthenticationTokensResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
    /**
     * Updates an existing host authentication token.
     *
     * Use this method to:
     * - Refresh token values
     * - Update expiration
     * - Modify token settings
     *
     * ### Examples
     *
     * - Update token:
     *
     *   Updates token value and expiration.
     *
     *   ```yaml
     *   id: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
     *   token: "gho_xxxxxxxxxxxx"
     *   expiresAt: "2024-12-31T23:59:59Z"
     *   refreshToken: "ghr_xxxxxxxxxxxx"
     *   ```
     *
     * @generated from rpc gitpod.v1.RunnerConfigurationService.UpdateHostAuthenticationToken
     */
    updateHostAuthenticationToken: {
      name: "UpdateHostAuthenticationToken",
      I: UpdateHostAuthenticationTokenRequest,
      O: UpdateHostAuthenticationTokenResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Deletes a host authentication token.
     *
     * Use this method to:
     * - Remove unused tokens
     * - Revoke access
     * - Clean up expired tokens
     *
     * ### Examples
     *
     * - Delete token:
     *
     *   Permanently removes a token.
     *
     *   ```yaml
     *   id: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
     *   ```
     *
     * @generated from rpc gitpod.v1.RunnerConfigurationService.DeleteHostAuthenticationToken
     */
    deleteHostAuthenticationToken: {
      name: "DeleteHostAuthenticationToken",
      I: DeleteHostAuthenticationTokenRequest,
      O: DeleteHostAuthenticationTokenResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Gets the latest runner configuration schema.
     *
     * Use this method to:
     * - View available settings
     * - Check configuration options
     * - Validate configurations
     *
     * ### Examples
     *
     * - Get schema:
     *
     *   Retrieves configuration schema for a runner.
     *
     *   ```yaml
     *   runnerId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
     *   ```
     *
     * @generated from rpc gitpod.v1.RunnerConfigurationService.GetRunnerConfigurationSchema
     */
    getRunnerConfigurationSchema: {
      name: "GetRunnerConfigurationSchema",
      I: GetRunnerConfigurationSchemaRequest,
      O: GetRunnerConfigurationSchemaResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
    /**
     * Creates a new SCM integration for a runner.
     *
     * Use this method to:
     * - Configure source control access
     * - Set up repository integrations
     * - Enable code synchronization
     *
     * ### Examples
     *
     * - Create GitHub integration:
     *
     *   Sets up GitHub SCM integration.
     *
     *   ```yaml
     *   runnerId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
     *   scmId: "github"
     *   host: "github.com"
     *   oauthClientId: "client_id"
     *   oauthPlaintextClientSecret: "client_secret"
     *   ```
     *
     * @generated from rpc gitpod.v1.RunnerConfigurationService.CreateSCMIntegration
     */
    createSCMIntegration: {
      name: "CreateSCMIntegration",
      I: CreateSCMIntegrationRequest,
      O: CreateSCMIntegrationResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Gets details about a specific SCM integration.
     *
     * Use this method to:
     * - View integration settings
     * - Check integration status
     * - Verify configuration
     *
     * ### Examples
     *
     * - Get integration details:
     *
     *   Retrieves information about a specific integration.
     *
     *   ```yaml
     *   id: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
     *   ```
     *
     * @generated from rpc gitpod.v1.RunnerConfigurationService.GetSCMIntegration
     */
    getSCMIntegration: {
      name: "GetSCMIntegration",
      I: GetSCMIntegrationRequest,
      O: GetSCMIntegrationResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
    /**
     * Lists SCM integrations for a runner.
     *
     * Use this method to:
     * - View all integrations
     * - Monitor integration status
     * - Check available SCMs
     *
     * ### Examples
     *
     * - List integrations:
     *
     *   Shows all SCM integrations.
     *
     *   ```yaml
     *   filter:
     *     runnerIds: ["d2c94c27-3b76-4a42-b88c-95a85e392c68"]
     *   pagination:
     *     pageSize: 20
     *   ```
     *
     * @generated from rpc gitpod.v1.RunnerConfigurationService.ListSCMIntegrations
     */
    listSCMIntegrations: {
      name: "ListSCMIntegrations",
      I: ListSCMIntegrationsRequest,
      O: ListSCMIntegrationsResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
    /**
     * Updates an existing SCM integration.
     *
     * Use this method to:
     * - Modify integration settings
     * - Update credentials
     * - Change configuration
     *
     * ### Examples
     *
     * - Update integration:
     *
     *   Updates OAuth credentials.
     *
     *   ```yaml
     *   id: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
     *   oauthClientId: "new_client_id"
     *   oauthPlaintextClientSecret: "new_client_secret"
     *   ```
     *
     * @generated from rpc gitpod.v1.RunnerConfigurationService.UpdateSCMIntegration
     */
    updateSCMIntegration: {
      name: "UpdateSCMIntegration",
      I: UpdateSCMIntegrationRequest,
      O: UpdateSCMIntegrationResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Deletes an SCM integration.
     *
     * Use this method to:
     * - Remove unused integrations
     * - Clean up configurations
     * - Revoke SCM access
     *
     * ### Examples
     *
     * - Delete integration:
     *
     *   Removes an SCM integration.
     *
     *   ```yaml
     *   id: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
     *   ```
     *
     * @generated from rpc gitpod.v1.RunnerConfigurationService.DeleteSCMIntegration
     */
    deleteSCMIntegration: {
      name: "DeleteSCMIntegration",
      I: DeleteSCMIntegrationRequest,
      O: DeleteSCMIntegrationResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Creates a new environment class for a runner.
     *
     * Use this method to:
     * - Define compute resources
     * - Configure environment settings
     * - Set up runtime options
     *
     * ### Examples
     *
     * - Create environment class:
     *
     *   Creates a new environment configuration.
     *
     *   ```yaml
     *   runnerId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
     *   displayName: "Large Instance"
     *   description: "8 CPU, 16GB RAM"
     *   configuration:
     *     - key: "cpu"
     *       value: "8"
     *     - key: "memory"
     *       value: "16384"
     *   ```
     *
     * @generated from rpc gitpod.v1.RunnerConfigurationService.CreateEnvironmentClass
     */
    createEnvironmentClass: {
      name: "CreateEnvironmentClass",
      I: CreateEnvironmentClassRequest,
      O: CreateEnvironmentClassResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Gets details about a specific environment class.
     *
     * Use this method to:
     * - View class configuration
     * - Check resource settings
     * - Verify availability
     *
     * ### Examples
     *
     * - Get class details:
     *
     *   Retrieves information about a specific class.
     *
     *   ```yaml
     *   environmentClassId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
     *   ```
     *
     * @generated from rpc gitpod.v1.RunnerConfigurationService.GetEnvironmentClass
     */
    getEnvironmentClass: {
      name: "GetEnvironmentClass",
      I: GetEnvironmentClassRequest,
      O: GetEnvironmentClassResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
    /**
     * Lists environment classes with optional filtering.
     *
     * Use this method to:
     * - View available classes
     * - Filter by capability
     * - Check enabled status
     *
     * ### Examples
     *
     * - List all classes:
     *
     *   Shows all environment classes.
     *
     *   ```yaml
     *   pagination:
     *     pageSize: 20
     *   ```
     *
     * - Filter enabled classes:
     *
     *   Lists only enabled environment classes.
     *
     *   ```yaml
     *   filter:
     *     enabled: true
     *   pagination:
     *     pageSize: 20
     *   ```
     * buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE
     *
     * @generated from rpc gitpod.v1.RunnerConfigurationService.ListEnvironmentClasses
     */
    listEnvironmentClasses: {
      name: "ListEnvironmentClasses",
      I: ListEnvironmentClassesRequest,
      O: ListEnvironmentClassesResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
    /**
     * Updates an environment class.
     *
     * Use this method to:
     * - Modify class settings
     * - Update resource limits
     * - Change availability
     *
     * ### Examples
     *
     * - Update class:
     *
     *   Changes class configuration.
     *
     *   ```yaml
     *   environmentClassId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
     *   displayName: "Updated Large Instance"
     *   description: "16 CPU, 32GB RAM"
     *   enabled: true
     *   ```
     *
     * @generated from rpc gitpod.v1.RunnerConfigurationService.UpdateEnvironmentClass
     */
    updateEnvironmentClass: {
      name: "UpdateEnvironmentClass",
      I: UpdateEnvironmentClassRequest,
      O: UpdateEnvironmentClassResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Validates a runner configuration.
     *
     * Use this method to:
     * - Check configuration validity
     * - Verify integration settings
     * - Validate environment classes
     *
     * ### Examples
     *
     * - Validate SCM integration:
     *
     *   Checks if an SCM integration is valid.
     *
     *   ```yaml
     *   runnerId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
     *   scmIntegration:
     *     id: "integration-id"
     *     scmId: "github"
     *     host: "github.com"
     *     oauthClientId: "client_id"
     *     oauthPlaintextClientSecret: "client_secret"
     *   ```
     *
     * @generated from rpc gitpod.v1.RunnerConfigurationService.ValidateRunnerConfiguration
     */
    validateRunnerConfiguration: {
      name: "ValidateRunnerConfiguration",
      I: ValidateRunnerConfigurationRequest,
      O: ValidateRunnerConfigurationResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Creates a new LLM integration for a runner.
     *
     * Use this method to:
     * - Configure LLM access
     * - Set up LLM integrations
     * - Enable LLM usage
     *
     * @generated from rpc gitpod.v1.RunnerConfigurationService.CreateLLMIntegration
     */
    createLLMIntegration: {
      name: "CreateLLMIntegration",
      I: CreateLLMIntegrationRequest,
      O: CreateLLMIntegrationResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Gets details about a specific LLM integration.
     *
     * Use this method to:
     * - View integration settings
     * - Check integration status
     * - Verify configuration
     *
     * ### Examples
     *
     * - Get integration details:
     *
     *   Retrieves information about a specific integration.
     *
     *   ```yaml
     *   id: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
     *   ```
     *
     * @generated from rpc gitpod.v1.RunnerConfigurationService.GetLLMIntegration
     */
    getLLMIntegration: {
      name: "GetLLMIntegration",
      I: GetLLMIntegrationRequest,
      O: GetLLMIntegrationResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
    /**
     * Lists LLM integrations for a runner.
     *
     * Use this method to:
     * - View all integrations
     * - Monitor integration status
     * - Check available LLMs
     *
     * ### Examples
     *
     * - List integrations:
     *
     *   Shows all LLM integrations.
     *
     *   ```yaml
     *   filter:
     *     runnerIds: ["d2c94c27-3b76-4a42-b88c-95a85e392c68"]
     *   pagination:
     *     pageSize: 20
     *   ```
     *
     * @generated from rpc gitpod.v1.RunnerConfigurationService.ListLLMIntegrations
     */
    listLLMIntegrations: {
      name: "ListLLMIntegrations",
      I: ListLLMIntegrationsRequest,
      O: ListLLMIntegrationsResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
    /**
     * Updates an existing LLM integration.
     *
     * Use this method to:
     * - Modify integration settings
     * - Update credentials
     * - Change configuration
     *
     * ### Examples
     *
     * - Update integration:
     *
     *   Updates OAuth credentials.
     *
     *   ```yaml
     *   id: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
     *   apiKey: "sk-..."
     *   ```
     *
     * @generated from rpc gitpod.v1.RunnerConfigurationService.UpdateLLMIntegration
     */
    updateLLMIntegration: {
      name: "UpdateLLMIntegration",
      I: UpdateLLMIntegrationRequest,
      O: UpdateLLMIntegrationResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Deletes an LLM integration.
     *
     * Use this method to:
     * - Remove unused integrations
     * - Clean up configurations
     * - Revoke LLM access
     *
     * ### Examples
     *
     * - Delete integration:
     *
     *   Removes an LLM integration.
     *
     *   ```yaml
     *   id: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
     *   ```
     *
     * @generated from rpc gitpod.v1.RunnerConfigurationService.DeleteLLMIntegration
     */
    deleteLLMIntegration: {
      name: "DeleteLLMIntegration",
      I: DeleteLLMIntegrationRequest,
      O: DeleteLLMIntegrationResponse,
      kind: MethodKind.Unary,
    },
  }
} as const;

